import Web3 from "web3";
export const weiToEth=(wei:number=0)=>{
    return Web3.utils.fromWei(wei.toString(),"ether")
}